import { CLEAN_GET_CHANNEL, CLEAN_GET_CHANNEL_ERROR } from '_models/redux/types';

export const cleanChangeEsimToSimAction = () => async (dispatch) => {
  try {
    dispatch({
      payload: undefined,
      type: CLEAN_GET_CHANNEL,
    });
  } catch (e) {
    dispatch({
      payload: undefined,
      type: CLEAN_GET_CHANNEL_ERROR,
    });
  }
};
